import { IconButton, Chip, Stack, Tooltip } from "@mui/material";
import { FaEnvelope, FaMagnifyingGlass, FaComments } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ListingPage from "../../components/DynamicListingPage";
import { useQuery } from "@tanstack/react-query";
import { usePermissions } from "../../providers/PermissionsProvider";
import { useState } from "react";
import { getQuotes } from "../../helpers/http_quotes_requests ";
import { getCategories } from "../../helpers/http_categories_requests";
import { getCustomers } from "../../helpers/http_customers_requests";

function resolveAdminQuoteLabel(row) {
    if (row.completed_at) {
        return { label: "CONCLUÍDO", color: "default" };
    }
    if (row.is_answered === "1" || row.is_answered === 1) {
        return { label: "RESPONDIDO", color: "success" };
    }
    return { label: "PENDENTE", color: "error" };
}

export default function Quotes() {

    const { verifyPermission } = usePermissions();

    // Estado para filtros
    const [filterValues, setFilterValues] = useState({});

    const handleFilterChange = (field, value) => {
        setFilterValues((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const { data, isFetching } = useQuery({
        queryKey: ["getQuotes", filterValues],
        queryFn: () => getQuotes(filterValues),
        staleTime: 1000 * 5,
    });

    const { data: dataList } = data?.data ?? {};

    const { data: categoriesData } = useQuery({
        queryKey: ["categories"],
        queryFn: getCategories,
        staleTime: 1000 * 60 * 10, // cache de 10 minutos
    });

    const { data: customersData } = useQuery({
        queryKey: ["customers"],
        queryFn: getCustomers,
        staleTime: 1000 * 60 * 10,
    });

    const categories = categoriesData?.data?.data ?? [];

    const { customers } = customersData?.data ?? [];

    const columns = [
        { field: "image", headerName: "Foto" },
        { field: "name", headerName: "Produto" },
        { field: "category_name", headerName: "Categoria" },
        { field: "customer_name", headerName: "Cliente" },
        { field: "created_at", headerName: "Data" },
        { field: "is_answered", headerName: "Status" },
        { field: "actions", headerName: "Ação", type: "number" },
    ];

    const componentName = "quotation";

    const filters = [
        {
            field: "completed",
            type: "select",
            label: "Situação",
            options: [
                { value: "0", label: "Aberto" },
                { value: "1", label: "Concluído" },
            ],
        },
        {
            field: "is_answered",
            type: "select",
            label: "Resposta",
            options: [
                { value: "0", label: "Pendente" },
                { value: "1", label: "Respondido" },
            ],
        },
        {
            field: "category",
            type: "select",
            label: "Categoria",
            options: categories?.map((cat) => ({
                value: cat.id,
                label: cat.name,
            })),
        },
        {
            field: "customer",
            type: "select",
            label: "Cliente",
            options: customers?.map((cust) => ({
                value: cust.id,
                label: cust.complete_name,
            })),
        },
        { field: "created_at_start", type: "datepicker", label: "Data Início" },
        { field: "created_at_end", type: "datepicker", label: "Data Fim" },
    ];

    function renderStatus(row) {
        const status = resolveAdminQuoteLabel(row);
        return (
            <Chip
                size="small"
                variant="outlined"
                color={status.color}
                label={status.label}
            />
        );
    }

    const renderActions = (row) => (
        <Stack spacing={1} direction="row" justifyContent="center">
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Detalhes / Conversa" arrow placement="top">
                    <IconButton component={Link} to={`/orcamento-detalhes/${row.id}`} color="primary">
                        <FaMagnifyingGlass size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 2) && !row.completed_at && (
                <Tooltip title="Abrir conversa" arrow placement="top">
                    <IconButton
                        component={Link}
                        to={`/orcamento-detalhes/${row.id}`}
                        color="primary"
                    >
                        <FaComments size={20} />
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
    );

    return (
        <ListingPage
            isLoading={isFetching}
            icon={FaEnvelope}
            pageTitle="Orçamentos"
            disabledAddButton
            columns={columns}
            data={dataList}
            answeredFunction={renderStatus}
            actions={renderActions}
            filters={filters}
            filterValues={filterValues}
            onFilterChange={handleFilterChange}
        />
    );
}
